module.exports = __webpack_public_path__ + "static/media/tj.980d12c9.svg";